import React, { memo } from 'react';
import noop from 'lodash/noop';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import { ISSUE_HIERARCHY_LEVEL_EPIC } from '@atlassian/jira-issue-type-hierarchies/src/index.tsx';
import { VISIBLE } from '@atlassian/jira-platform-inline-card-create/src/common/constants.tsx';
import { ContextualAnalyticsData } from '@atlassian/jira-product-analytics-bridge';
import InlineCardCreate from '../../../../common/ui/inline-card-create/main.tsx';
import messages from './messages.tsx';
import type { EpicInlineCardCreateProps } from './types.tsx';

const EpicInlineCardCreate = ({
	epicIssueType,
	triggerAppearance = VISIBLE,
	onCreate = noop,
	intl: { formatMessage },
}: EpicInlineCardCreateProps) => (
	<ContextualAnalyticsData attributes={{ issueHierarchyLevel: ISSUE_HIERARCHY_LEVEL_EPIC }}>
		<InlineCardCreate
			id={epicIssueType.id}
			triggerAppearance={triggerAppearance}
			triggerLabel={formatMessage(messages.triggerLabel, {
				epicIssueTypeNameLowerCase: epicIssueType?.name?.toLocaleLowerCase(),
			})}
			placeholder={formatMessage(messages.createPlaceholder, {
				epicIssueTypeName: epicIssueType.name,
			})}
			onCreate={onCreate}
		/>
	</ContextualAnalyticsData>
);

export { EpicInlineCardCreate };

export default injectIntl(memo<EpicInlineCardCreateProps>(EpicInlineCardCreate));
